/*
  Copyright John Josef | uh-sem-blee, Co. | typefoo
*/

const MAX_SIZE = 200
const MIN_SIZE = 50
const MAX_SPEED = 30
const MIN_SPEED = 2
const MAX_OPACITY = 0.4
const MIN_OPACITY = 0.2
const MAX_VECTOR = 360
const MIN_VECTOR = 0
const MAX_LIFE = 20000
const MIN_LIFE = 5000

class ParticleModel {
	constructor (config) {
		const defaults = {
			displayed : false,
			ended     : false,
			size      : 0,
			x         : 0,
			y         : 0,
			speed     : 0,
			opacity   : 1,
			vector    : 0,
			domElement: document.createElement('div'),
			id        : undefined, // should be defined in config
			boxSize   : { width: 0, height: 0 }, // should be defined in config
			header    : undefined, // should be defined in config
			controller: undefined // should be defined in config
		}

		defaults.domElement.classList.add('particle')

		this.config = Object.assign(defaults, config)
	}

	randRange (min, max, round) {
		if (round === undefined) {
			return Math.floor(Math.random() * (max - min) + min)
		} else if (round === false) {
			return Math.random() * (max - min) + min
		}
	}

	init () {
		this.config.size = this.randRange(MIN_SIZE, MAX_SIZE)
		this.config.speed = this.randRange(MIN_SPEED, MAX_SPEED)
		this.config.x = this.randRange(0, this.config.boxSize.width)
		this.config.y = this.randRange(0, this.config.boxSize.height)
		this.config.opacity = this.randRange(MIN_OPACITY, MAX_OPACITY, false)
		if (this.config.size > 100) {
			this.config.opacity = this.randRange(0.01, 0.2, false)
		}
		this.config.blur = this.config.size / 8
		this.config.vector = this.randRange(MIN_VECTOR, MAX_VECTOR)
		this.config.xspeed = Math.cos(this.config.vector) * this.config.speed
		this.config.yspeed = Math.sin(this.config.vector) * this.config.speed
		var createTime = new Date().getTime()
		var expires = new Date().getTime() + this.randRange(MIN_LIFE, MAX_LIFE)
		this.config.life = expires - createTime

		this.updateDOMStyles()

		this.config.x += Math.floor(this.config.xspeed * this.config.life / 1000)
		this.config.y += Math.floor(this.config.yspeed * this.config.life / 1000)

		this.updateXY()

		this.config.domElement.addEventListener('webkitTransitionEnd', this.particleEnd.bind(this))
		this.config.domElement.addEventListener('transitionend', this.particleEnd.bind(this))
		return this
	}

	particleEnd () {
		if (this.config.displayed === false) {
			this.config.displayed = true
			return
		}
		if (this.config.ended === false) {
			Object.assign(this.config.domElement.style, {
				transition      : 'opacity 1s linear',
				WebkitTransition: 'opacity 1s linear',
				MozTransition   : 'opacity 1s linear'
			})
			const style1 = document.querySelector('style#style-' + this.config.id)
			style1.innerHTML = '.animated-' + this.config.id + ' { opacity: 0 !important; transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) !important; -webkit-transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) !important; -moz-transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) !important; }'
			this.config.ended = true
			return
		}

		const style = document.querySelector('style#style-' + this.config.id)
		document.getElementsByTagName('head')[0].removeChild(style)
		this.config.ended = true
		this.config.domElement.parentNode.removeChild(this.config.domElement)

		var p = new ParticleModel({
			id     : this.config.controller.numParticles,
			boxSize: {
				width : this.config.header.offsetWidth,
				height: this.config.header.offsetHeight
			},
			header    : this.config.header,
			controller: this.config.controller
		}).init()

		this.config.controller.numParticles++
		this.config.header.append(p.config.domElement)
	}

	updateDOMStyles () {
		Object.assign(this.config.domElement.style, {
			width           : this.config.size + 'px',
			height          : this.config.size + 'px',
			borderRadius    : (this.config.size / 2) + 'px',
			webkitFilter    : 'blur(' + this.config.blur + 'px)',
			filter          : 'blur(' + this.config.blur + 'px)',
			transition      : 'transform ' + (this.config.life / 1000) + 's linear, opacity 1s linear',
			WebkitTransition: '-webkit-transform ' + (this.config.life / 1000) + 's linear, opacity 1s linear',
			MozTransition   : '-moz-transform ' + (this.config.life / 1000) + 's linear, opacity 1s linear',
			transform       : 'translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1)',
			webkitTransform : 'translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1)',
			MozTransform    : 'translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1)'
		})
	}

	updateXY () {
		const className = 'animated-' + this.config.id
		const style = document.createElement('style')
		style.type = 'text/css'
		style.id = 'style-' + this.config.id
		style.innerHTML = '.' + className + ' { opacity: ' + this.config.opacity + ' !important; transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1) !important; -webkit-transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1) !important; -moz-transform: translate3d(' + this.config.x + 'px, ' + this.config.y + 'px, 0px) scale3d(1,1,1) !important; }'
		document.getElementsByTagName('head')[0].appendChild(style)
		setTimeout(() => {
			this.config.domElement.classList.add(className)
		}, 100)
	}
}

class ParticleController {
	constructor (config) {
		const defaults = {
			numberOfParticles: 0, // should be defined in config;
			header           : undefined // should be defined in config
		}

		this.config = Object.assign(defaults, config)
		this.numParticles = 0
	}

	init () {
		for (let i = 0; i < this.config.numberOfParticles; i++) {
			const p = new ParticleModel({
				id     : i + 1,
				boxSize: {
					width : this.config.header.offsetWidth,
					height: this.config.header.offsetHeight
				},
				header    : this.config.header,
				controller: this
			})
			p.init()

			this.numParticles++
			this.config.header.append(p.config.domElement)
		}
		return this
	}
}

export default ParticleController
